import { appointmentTypeKey } from '@/utils/appointmentFrequency';

import { calendarDateIso } from './existingAppointmentDos';

/** Real appointment ids. The schedule list also appends "-1", "-2", … for projected dates. */
const REAL_APPOINTMENT_ID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

const SELECTABLE_STATUSES = new Set(['scheduled', 'pending', 'no show']);

export interface CreateTaskScheduleRow {
  id: string;
  status?: string | null;
  scheduledDate?: string | null;
  type?: string | null;
  deviceId?: string | null;
}

/**
 * Appointments that can be tied to a new transmission task.
 * Same rows as the patient schedule, limited to this device, a real id,
 * scheduled / pending / no show, and a calendar date on or before today.
 * Ad hoc visits are omitted: they are not a transmission-task selection.
 * An appointment already tied to a transmission-tracking task is omitted.
 */
export function selectableCreateTaskAppointments(
  rows: CreateTaskScheduleRow[],
  deviceId: string,
  todayIso: string,
  options?: { excludeAdHoc?: boolean; transmissionTaskAppointmentIds?: ReadonlySet<string> }
): CreateTaskScheduleRow[] {
  if (!deviceId || !todayIso) return [];
  const seen = new Set<string>();
  return rows.filter((row) => {
    if (row.deviceId !== deviceId) return false;
    if (options?.transmissionTaskAppointmentIds?.has(row.id)) return false;
    if (!REAL_APPOINTMENT_ID.test(row.id)) return false;
    if (!SELECTABLE_STATUSES.has(appointmentTypeKey(row.status))) return false;
    if (options?.excludeAdHoc && appointmentTypeKey(row.type) === 'ad hoc') return false;
    const day = calendarDateIso(row.scheduledDate);
    if (!day || day > todayIso) return false;
    if (seen.has(row.id)) return false;
    seen.add(row.id);
    return true;
  });
}
